<template>
      <main class="column main">
        

        <div class="level">
          <div class="level-left">
            <div class="level-item">
              <div class="title has-text-primary"><i class="fa fa-tachometer"></i> Dashboard</div>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <button type="button" class="button is-small">
                March 8, 2017 - April 6, 2017
              </button>
            </div>
          </div>
        </div>

        <div class="columns is-multiline">
          <div class="column">
            <div class="box notification is-primary">
              <div class="heading">Top Seller Total</div>
              <div class="title">
                <number
                      ref="number1"
                      :from="0"
                      :to=" number_obj[0]['number1']['to'] " 
                      :format="theFormat"
                      :duration="1"
                      :delay="0.5"
                      />
              </div>
              <div class="level">
                <div class="level-item">
                  <div class="">
                    <div class="heading">Sales $</div>
                    <div class="title is-5">
                      <number
                      ref="number1"
                      :from="0"
                      :to=" number_obj[0]['number2']['to'] " 
                      :format="theFormat"
                      :duration="1"
                      :delay="0.5"
                      /> K</div>
                  </div>
                </div>
                <div class="level-item">
                  <div class="">
                    <div class="heading">Overall $</div>
                    <div class="title is-5">
                      <number
                      ref="number1"
                      :from="0"
                      :to=" number_obj[0]['number3']['to'] " 
                      :format="theFormat"
                      :duration="1"
                      :delay="0.5"
                      /> K</div>
                  </div>
                </div>
                <div class="level-item">
                  <div class="">
                    <div class="heading">Sales %</div>
                    <div class="title is-5">
                      <number
                      ref="number1"
                      :from="0"
                      :to=" number_obj[0]['number4']['to'] " 
                      :format="theFormat"
                      :duration="1"
                      :delay="0.5"
                      /> %</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="box notification is-warning">
              <div class="heading">Revenue / Expenses</div>
              <div class="title">55% / 45%</div>
              <div class="level">
                <div class="level-item">
                  <div class="">
                    <div class="heading">Rev Prod $</div>
                    <div class="title is-5">30%</div>
                  </div>
                </div>
                <div class="level-item">
                  <div class="">
                    <div class="heading">Rev Serv $</div>
                    <div class="title is-5">25%</div>
                  </div>
                </div>
                <div class="level-item">
                  <div class="">
                    <div class="heading">Exp %</div>
                    <div class="title is-5">45%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="box notification is-info">
              <div class="heading">Feedback Activity</div>
              <div class="title">78% &uarr;</div>
              <div class="level">
                <div class="level-item">
                  <div class="">
                    <div class="heading">Pos</div>
                    <div class="title is-5">1560</div>
                  </div>
                </div>
                <div class="level-item">
                  <div class="">
                    <div class="heading">Neg</div>
                    <div class="title is-5">368</div>
                  </div>
                </div>
                <div class="level-item">
                  <div class="">
                    <div class="heading">Pos/Neg %</div>
                    <div class="title is-5">77% / 23%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="box notification is-danger">
              <div class="heading">Orders / Returns</div>
              <div class="title">75% / 25%</div>
              <div class="level">
                <div class="level-item">
                  <div class="">
                    <div class="heading">Orders $</div>
                    <div class="title is-5">425K</div>
                  </div>
                </div>
                <div class="level-item">
                  <div class="">
                    <div class="heading">Returns $</div>
                    <div class="title is-5">106K</div>
                  </div>
                </div>
                <div class="level-item">
                  <div class="">
                    <div class="heading">Success %</div>
                    <div class="title is-5">+ 28,5%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
<!--  -->
        <div class="columns is-multiline">
          <!--  -->
          <div class="column is-6 ">
            <div class="panel ">
              <p class="panel-heading">
                Recent Result Lab
              </p>
              <div class="panel-block  ">
                <div class="container">
                            <b-table 
                              
                            :data="isEmpty ? [] : data_table1"
                            :bordered="isBordered"
                            :striped="isStriped"
                            :narrowed="isNarrowed"
                            :hoverable="isHoverable"
                            :loading="isLoading"
                            :focusable="isFocusable"
                            :mobile-cards="hasMobileCards">


                                    <b-table-column field="id" label="ID" width="40" numeric v-slot="props">
                                        {{ props.row.id }}
                                    </b-table-column>

                                    <b-table-column field="first_name" label="First Name" v-slot="props">
                                        {{ props.row.first_name }}
                                    </b-table-column>

                                    <b-table-column field="last_name" label="Last Name" v-slot="props">
                                        {{ props.row.last_name }}
                                    </b-table-column>

                                    <b-table-column field="date" label="Date" centered v-slot="props">
                                        <span class="tag is-success">
                                            {{ new Date(props.row.date).toLocaleDateString() }}
                                        </span>
                                    </b-table-column>

                                    <b-table-column label="Gender" v-slot="props">
                                        <span>
                                            <b-icon pack="fas"
                                                :icon="props.row.gender === 'Male' ? 'mars' : 'venus'">
                                            </b-icon>
                                            {{ props.row.gender }}
                                        </span>
                                    </b-table-column>


                                <template slot="empty">
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p>
                                                <b-icon
                                                    icon="emoticon-sad"
                                                    size="is-large">
                                                </b-icon>
                                            </p>
                                            <p>Nothing here.</p>
                                        </div>
                                    </section>
                                </template>
                            </b-table>
                    </div>        
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="panel">
              <p class="panel-heading">
                Some other table
              </p>
              <div class="panel-block">
                  <!-- Hier kommt dann die sortable Data Table -->
                  <h1>data...</h1>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="column is-6">
            <div class="panel">
              <p class="panel-heading">
                PCV vs BUN vs Cretinine
              </p>   
              <div class="container">
                  <div class="panel-block ">
                    <LineChart_1 />
                  </div>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="panel">
              <p class="panel-heading">
                Chart - Scatter Style (Chart.js)
              </p>
              <div class="panel-block">
                <!-- <canvas id="chartScatter" width="400" height="400"></canvas> -->
                  <LineChart_1 />
              </div>
            </div>
          </div>

          <div class="column is-6">
            <div class="panel">
              <p class="panel-heading">
                Chart - Doughnut
              </p>   
              <div class="panel-block">
                  <DoughnutChart_1 />
              </div>
            </div>
          </div>

          
          <div class="column is-6">
            <div class="panel">
              <p class="panel-heading">
                Chart - Scatter
              </p>   
              <div class="panel-block">
                  <ScatterChart_1 />
              </div>
            </div>
          </div>

        </div>

        
      </main>
</template>



<script>
/* eslint-disable */

import LineChart_1 from './Chart/LineChartComp'
import DoughnutChart_1 from './Chart/DoughnutComp'
import ScatterChart_1 from './Chart/ScatterComp'
import { getRandomInt } from '@/utils.js'

export default {
    name : 'Dashboard',
    components: {
      LineChart_1,
      DoughnutChart_1,
      ScatterChart_1
    },
    data() {
      return {
          data_table1 : [
                      { 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016/10/15 13:43:27', 'gender': 'Male' },
                      { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016/12/15 06:00:53', 'gender': 'Male' },
                      { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016/04/26 06:26:28', 'gender': 'Female' },
                      { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016/04/10 10:28:46', 'gender': 'Male' },
                      { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016/12/06 14:38:38', 'gender': 'Female' }
                ],
          isEmpty: false,
          isBordered: true,
          isStriped: true,
          isNarrowed: false,
          isHoverable: true,
          isFocusable: true,
          isLoading: false,
          hasMobileCards: true  ,    
          "number_obj" :   [
                            {
                              "number1" : {
                                            "to" : 0
                                          } ,
                              "number2" : {
                                            "to" : 0
                                          } ,
                              "number3" : {
                                            "to" : 0
                                          }  , 
                              "number4" : {
                                            "to" : 0
                                          }                        
                            } 
                           ] 
      }
    }
    ,
    mounted() {
      this.playAnimation()
      // random data into var
      this.number_obj[0]["number1"]["to"] = getRandomInt()
      this.number_obj[0]["number2"]["to"] = getRandomInt()
      this.number_obj[0]["number3"]["to"] = getRandomInt()
      this.number_obj[0]["number4"]["to"] = getRandomInt()

    },
    methods: {
       
       theFormat(number) {
        return number.toFixed(0);
       },
       
       playAnimation() {
         this.scaleClass = false;
         this.$refs.number1.play();
        }
    }
}
</script>